import gql from 'graphql-tag';

export const GET_REFEREE_FORM_INFO = gql`
  query ($formId: ID!) {
    getRefereeFormInfo(formId: $formId) {
      nameOfApplicant
      department
      programme
      researchArea
    }
  }
`;
